import { getLocale } from "lib/apolloClient"

export const useHomeUrl = (): string => {
  const prodUrl = "https://www.beautypie.com"

  const homeUrl = `${prodUrl}${getLocale() === "en-US" ? "/us" : ""}`
  return homeUrl
}
